export default {
    data() {
        return {
            languages: [
                {
                    name: this.$t('common.languages.en'),
                    value: 'en',
                    id: 1
                },
                {
                    name: this.$t('common.languages.ar'),
                    value: 'ar',
                    rtl: true,
                    id: 2
                },
                {
                    name: this.$t('common.languages.zh-cn'),
                    value: 'zh-CN',
                    id: 3
                },
                {
                    name: this.$t('common.languages.zh-tw'),
                    value: 'zh-TW',
                    id: 4
                },
                {
                    name: this.$t('common.languages.cs'),
                    value: 'cs',
                    id: 5
                },
                {
                    name: this.$t('common.languages.de'),
                    value: 'de',
                    id: 6
                },
                {
                    name: this.$t('common.languages.fr'),
                    value: 'fr',
                    id: 7
                },
                {
                    name: this.$t('common.languages.nl'),
                    value: 'nl',
                    id: 8
                },
                {
                    name: this.$t('common.languages.hi'),
                    value: 'hi',
                    id: 9
                },
                {
                    name: this.$t('common.languages.it'),
                    value: 'it',
                    id: 10
                },
                {
                    name: this.$t('common.languages.ja'),
                    value: 'ja',
                    id: 11
                },
                {
                    name: this.$t('common.languages.ko'),
                    value: 'ko',
                    id: 12
                },
                {
                    name: this.$t('common.languages.pl'),
                    value: 'pl',
                    id: 13
                },
                {
                    name: this.$t('common.languages.pt'),
                    value: 'pt',
                    id: 14
                },
                {
                    name: this.$t('common.languages.es'),
                    value: 'es',
                    id: 15
                },
                {
                    name: this.$t('common.languages.tr'),
                    value: 'tr',
                    id: 16
                }
            ],
            languageValues: {
                'en': {
                    name: this.$t('common.languages.en'),
                    country: 'gb'
                },
                'ar': {
                    name: this.$t('common.languages.ar'),
                    country: 'ae'
                },
                'zh-CN': {
                    name: this.$t('common.languages.zh-cn'),
                    country: 'cn'
                },
                'zh-TW': {
                    name: this.$t('common.languages.zh-tw'),
                    country: 'cn'
                },
                'cs': {
                    name: this.$t('common.languages.cs'),
                    country: 'cz'
                },
                'de': {
                    name: this.$t('common.languages.de'),
                    country: 'de'
                },
                'fr': {
                    name: this.$t('common.languages.fr'),
                    country: 'fr'
                },
                'nl': {
                    name: this.$t('common.languages.nl'),
                    country: 'nl'
                },
                'hi': {
                    name: this.$t('common.languages.hi'),
                    country: 'in'
                },
                'it': {
                    name: this.$t('common.languages.it'),
                    country: 'it'
                },
                'ja': {
                    name: this.$t('common.languages.ja'),
                    country: 'jp'
                },
                'ko': {
                    name: this.$t('common.languages.ko'),
                    country: 'kr'
                },
                'pl': {
                    name: this.$t('common.languages.pl'),
                    country: 'pl'
                },
                'pt': {
                    name: this.$t('common.languages.pt'),
                    country: 'pt'
                },
                'es': {
                    name: this.$t('common.languages.es'),
                    country: 'es'
                },
                'tr': {
                    name: this.$t('common.languages.tr'),
                    country: 'tr'
                }
            }
        }
    },
}
